import { dynamicPseudoBlockColor } from '../constants'
import '../css/SemanticBlock.scss'
import { checkMark } from '../scripts/text'
import { toHex, toHexRgba } from '../scripts/utils'
import SemanticNode from './SemanticNode'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class SemanticBlock extends PureComponent {
  render() {
    const {
      order,
      startCount,
      textSubArray,
      color,
      focused,
      selected,
      selectedRef,
      pseudo,
      dynamicPseudoBlock,
      pseudoExpandSelectionResults,
      mode,
    } = this.props

    const firstOrderInBlock = textSubArray[0][2]
    const lastOrderInBlock = textSubArray[textSubArray.length - 1][2]

    let nodes = []
    for (let i in textSubArray) {
      let or = startCount + Number(i)
      const inPseudoAndLastOfPseudo =
        pseudo && (lastOrderInBlock === or || firstOrderInBlock === or)
      nodes.push(
        <SemanticNode
          key={`${or}:${textSubArray[i][0]}-${textSubArray[i][1]}-${
            textSubArray[i][2]
          }:${inPseudoAndLastOfPseudo ? ':inPseudoAndLastOfPseudo' : ''}${
            pseudo ? ':inPseudo' : ''
          }:${mode}`}
          count={or}
          text={textSubArray[i]}
          mark={checkMark(textSubArray[i][0])}
          color={color}
          pseudoExpandSelectionResults={pseudoExpandSelectionResults}
          inPseudo={pseudo}
          inPseudoAndLastOfPseudo={inPseudoAndLastOfPseudo}
          mode={mode}
        />
      )
    }

    const mark = checkArrayMark(textSubArray)
    const visBlock = focused && !mark // A visible block that one can operate on

    const theRef = {}
    if (selectedRef) theRef.ref = selectedRef

    return (
      <div
        className={
          'block' +
          (focused ? ' focused' : ' unfocused') +
          (mark ? ' mark-block' : ' has-text-block') +
          (selected ? ' selected' : '') +
          (pseudo ? ' pseudo' : '') +
          (dynamicPseudoBlock ? ' dynamic-pseudo' : '') +
          (lastNodeHasSpaceAfter(textSubArray) ? ' space-after' : '')
        }
        style={
          visBlock || pseudo || dynamicPseudoBlock
            ? {
                background: pseudo
                  ? `#${toHexRgba(
                      ...color.slice(0, 3),
                      Math.min(color[3], 255)
                    )}`
                  : dynamicPseudoBlock
                  ? `#${toHex(...dynamicPseudoBlockColor)}33`
                  : `#${toHex(...color)}33`,
                borderBottomColor: visBlock ? `#${toHex(...color)}` : '',
              }
            : null
        }
        data-color={color}
        data-order={order}
        {...theRef}
      >
        {nodes}
      </div>
    )
  }
}

// Check if an array contains only mark
// Return false if at least one element has non-punctuation string
const checkArrayMark = arr => {
  for (let a of arr) if (!checkMark(a[0])) return false
  return true
}

const lastNodeHasSpaceAfter = textArray => {
  if (!textArray.length) return true
  return textArray[textArray.length - 1][1]
}

SemanticBlock.propTypes = {
  order: PropTypes.number,
  textSubArray: PropTypes.array,
  startCount: PropTypes.number,
  color: PropTypes.array,
  focused: PropTypes.bool,
  selected: PropTypes.bool,
  selectedRef: PropTypes.object,
  pseudo: PropTypes.bool,
  dynamicPseudoBlock: PropTypes.bool,
  pseudoExpandSelectionResults: PropTypes.object,
  mode: PropTypes.string,
}
